// VideoBackground.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Col, Row, Card, ButtonToolbar, ButtonGroup, Image, InputGroup, Form, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart, faBible, faGift, faDollar } from '@fortawesome/free-solid-svg-icons';
import { faTwitter, faFacebook, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { serverurl } from '../../providers/ServerUrl';
import { ReactTyped } from 'react-typed';
import Modal from 'react-bootstrap/Modal';
import { VideoModal2 } from '../../components/VideoModal2';
import { Fade } from 'react-swift-reveal';
import { Carousel } from 'react-bootstrap';

import './Home.css';

export const Home = () => {

  /*********************************************************
   POST THE FORM DATA TO THE API AND GET THE SEARCH RESULT
  **********************************************************/
  const [productsearch, setProductSearch] = useState([]);
  const [getproductsearch, getProductSearch] = useState([]);
  const [nextevent, setNextEvent] = useState([]);
  const [sermons, setSermonAllOne] = useState([]);
  const [podcasts, setPodcastAllOne] = useState([]);

  const [buttontext, setButtonText] = useState('Search');
  const [message, setMessageText] = useState();
  const [successmessage, setSuccessMessage] = useState();
  const [errormessage, setErrorMessage] = useState();

  const [buttontextp, setButtonTextp] = useState('Send');
  const [messagep, setMessageTextp] = useState();
  const [successmessagep, setSuccessMessagep] = useState();
  const [errormessagep, setErrorMessagep] = useState();

  const [prayeruser_name, setPrayerUserName] = useState('');
  const [prayeruser_email, setPrayerUserEmail] = useState('');
  const [prayeruser_pnum, setPrayerUserPnum] = useState('');
  const [prayeruser_request, setPrayerRequest] = useState('');

  const Save = async () => {
    setButtonTextp("Processing");
    if (prayeruser_name === "" || prayeruser_email === "" || prayeruser_pnum === "" || prayeruser_request === "") {
      setMessageTextp("error");
      setErrorMessagep("All Fields are Required");
      setButtonTextp("Send");
    } else {
      try {
        const items = { prayeruser_name, prayeruser_email, prayeruser_pnum, prayeruser_request };
        const result = await axios.post(serverurl + "/api/prayer", items);
        setMessageTextp("success");
        setSuccessMessagep(result.data.message);
        setButtonTextp("Send");
        console.warn(result);
      } catch (error) {
        setMessageTextp("error");
        setErrorMessagep("!!Sorry, Your Message Could Not Be Processed");
        setButtonTextp("Send");
        console.log(error);
      }
    }
  };

  const getSearch = async () => {
    setButtonText("Processing");
    if (productsearch === "") {
      setMessageText("error");
      setErrorMessage("All Fields are Required");
      setButtonText("Search");
    } else {
      try {
        const items = { productsearch };
        const result = await axios.post(serverurl + "/api/productsearch", items);

        if (result.data.productsearchdata['productsearch_result'] === "Not Found") {
          setMessageText("error");
          setErrorMessage("");
        } else {
          setMessageText("success");
          setMessageText("");
          setSuccessMessage("");
          getProductSearch(result.data.productsearchdata);
          console.log(result.data);
        }
        setButtonText("Search");
      } catch (error) {
        setMessageText("error");
        setErrorMessage("!!Sorry, Your Request Could Not Be Processed");
        setButtonText("Search");
        console.log(error);
      }
    }
  };

  const [banner, setBanner] = useState([]);
  const [events, setEvents] = useState([]);
  const [productcategories, setProductCategories] = useState([]);
  const [productsbycat, setProductsByCat] = useState([]);
  const [productcategoriesid, setProductCategoriesID] = useState([]);

  const [news, setNews] = useState([]);

  const fetchNewsData = () => {
    return axios.get(serverurl + "/api/news")
      .then((response) => setNews(response.data['news']))
      .catch((err) => console.log(err));
  };

  const fetchBannerData = () => {
    return axios.get(serverurl + "/api/banner")
      .then((response) => setBanner(response.data['banners']))
      .catch((err) => console.log(err));
  };

  const fetchEventsData = () => {
    return axios.get(serverurl + "/api/event")
      .then((response) => setEvents(response.data['events']))
      .catch((err) => console.log(err));
  };

  const fetchProductCategoryData = () => {
    return axios.get(serverurl + "/api/productcategory")
      .then((response) => setProductCategories(response.data['productcategories']))
      .catch((err) => console.log(err));
  };

  const fetchNextEventData = () => {
    return axios.get(serverurl + "/api/nextevent")
      .then((response) => setNextEvent(response.data['event']))
      .catch((err) => console.log(err));
  };

  const fetchSermonsAllOneData = () => {
    return axios.get(serverurl + "/api/sermonallone")
      .then((response) => setSermonAllOne(response.data['sermons']))
      .catch((err) => console.log(err));
  };

  const fetchPodcastsAllOneData = () => {
    return axios.get(serverurl + "/api/podcastallone")
      .then((response) => setPodcastAllOne(response.data['podcasts']))
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchBannerData();
    fetchEventsData();
    fetchNextEventData();
    fetchSermonsAllOneData();
    fetchPodcastsAllOneData();
    fetchNewsData();
  }, []);

  const navigate = useNavigate();
  const goToAbout = () => {
    navigate('/about');
  };

  // Loading the Video Modal
  const [show, setShow] = useState(false);
  const [showFlipbook, setShowFlipbook] = useState(false);
  const [activeFlipbook, setActiveFlipbook] = useState({ title: '', url: '' });

  const openFlipbook = (title, url) => {
    setActiveFlipbook({ title, url });
    setShowFlipbook(true);
  };

  const closeFlipbook = () => {
    setShowFlipbook(false);
    setActiveFlipbook({ title: '', url: '' });
  };

  const publications = [
    {
      id: 1,
      title: "Grandma's Burial",
      desc: "",
      date: "June 2026",
      flipbook_url: "https://heyzine.com/flip-book/741b8b8b36.html"
    },
    {
      id: 2,
      title: "Grandma's Burial",
      desc: "",
      date: "June 2026",
      flipbook_url: "https://heyzine.com/flip-book/741b8b8b36.html"
    },
    {
      id: 3,
      title: "Grandma's Burial",
      desc: "",
      date: "June 2026",
      flipbook_url: "https://heyzine.com/flip-book/741b8b8b36.html"
    },
  ];

  const [videotitle, setVideoTitle] = useState();
  const [videoid, setVideoID] = useState();
  const handleClose = () => setShow(false);
  const values = [true, "sm-down", "md-down", "lg-down", "xl-down", "xxl-down"];
  const [fullscreen, setFullscreen] = useState(true);

  const loadVideo = (videotitle, videoid, breakpoint) => {
    setVideoTitle(videotitle);
    setVideoID(videoid);
    setFullscreen(breakpoint);
    setShow(true);
  };

  /**
   * 4-News Duplication Logic for Latest News:
   * "Each row is supposed to take 4 news.
   * If there are 3 news, repeat one of the 3 to make it 4.
   * If there are 2 news, repeat the 2 to make it 4.
   * If there is just one news, repeat it to make it 4.
   * This should be applied to all the rows."
   */
  const processNewsRows = (newsList) => {
    if (!newsList || newsList.length === 0) return [];
    
    // Filter out items without a valid title
    const validNews = newsList.filter(item => item && item.news_title && item.news_title.trim() !== '');
    if (validNews.length === 0) return [];

    const rows = [];
    const chunkSize = 4;

    for (let i = 0; i < validNews.length; i += chunkSize) {
      const chunk = validNews.slice(i, i + chunkSize);
      if (chunk.length === 1) {
        rows.push([chunk[0], chunk[0], chunk[0], chunk[0]]);
      } else if (chunk.length === 2) {
        rows.push([chunk[0], chunk[1], chunk[0], chunk[1]]);
      } else if (chunk.length === 3) {
        rows.push([chunk[0], chunk[1], chunk[2], chunk[0]]);
      } else {
        rows.push(chunk);
      }
    }

    return rows;
  };

  const newsRows = processNewsRows(news);

  return (
    <div className="home-page-wrapper">
      <VideoModal2 show={show} videoid={videoid} handleClose={handleClose} />

      {/* 1. HERO BANNER CAROUSEL */}
      <section className="home-hero-section">
        <Fade delay={200} duration={1500}>
          <Container fluid className="px-lg-4 px-md-3 px-2">
            <div className="home-hero-carousel-wrap">
              <Carousel indicators={true} controls={true} interval={6000}>
                {/* Slide 1 - Bishop */}
                <Carousel.Item>
                  <div className="home-hero-slide" id="homesermonimgdiv">
                    <Row className="align-items-center w-100 g-4">
                      <Col lg={7} md={12}>
                        <div className="home-hero-content" id="homebanner">
                          <div className="home-hero-badge">
                            <ReactTyped strings={["WELCOME TO"]} typeSpeed={120} loop />
                          </div>
                          <h1 className="home-hero-title">
                            ADE AJALA MINISTRIES
                          </h1>
                          <hr className="home-hero-divider" />
                          <p className="home-hero-desc">
                            We strive to empower individuals to depeen their relationship <br className="d-none d-md-inline" />
                            with God and live out their faith in meaningful ways
                          </p>
                          <div className="home-hero-btn-group">
                            <Link to='/livestream' reloadDocument className='btn btn-danger slidebtn' id='btn'>
                              JOIN SERVICE
                            </Link>
                            <Link to='/events' reloadDocument className='btn btn-danger slidebtn aam-btn-outline' id='btn'>
                              UPCOMING EVENT
                            </Link>
                          </div>
                        </div>
                      </Col>
                      <Col lg={5} md={12}>
                        <div className="home-hero-image-wrap" id="homeaboutimgdiv">
                          <Image src="images/Bishopimg.png" alt="Bishop Isreal Ade-Ajala" fluid id="homeaboutimg" className="home-hero-image" />
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Carousel.Item>

                {/* Slide 2 - Mobile App */}
                <Carousel.Item>
                  <div className="home-hero-slide" id="homesermonimgdiv">
                    <Row className="align-items-center w-100 g-4">
                      <Col lg={7} md={12}>
                        <div className="home-hero-content" id="homebanner">
                          <div className="home-hero-badge">
                            <ReactTyped strings={["WELCOME TO"]} typeSpeed={120} loop />
                          </div>
                          <h1 className="home-hero-title">
                            ADE AJALA MINISTRIES
                          </h1>
                          <hr className="home-hero-divider" />
                          <p className="home-hero-desc">
                            We strive to empower individuals to depeen their relationship <br className="d-none d-md-inline" />
                            with God and live out their faith in meaningful ways
                          </p>
                          <div className="home-hero-btn-group">
                            <Link to='/livestream' reloadDocument className='btn btn-danger slidebtn' id='btn'>
                              JOIN SERVICE
                            </Link>
                            <Link to='/events' reloadDocument className='btn btn-danger slidebtn aam-btn-outline' id='btn'>
                              UPCOMING EVENT
                            </Link>
                          </div>
                        </div>
                      </Col>
                      <Col lg={5} md={12}>
                        <div className="home-hero-image-wrap" id="homeaboutimgdiv">
                          <div id="appimgslide">
                            <Image fluid src="images/app.png" alt="AAM Mobile App" className="home-hero-image" />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Carousel.Item>

                {/* Slide 3 - Event */}
                <Carousel.Item>
                  <div className="home-hero-slide" id="homesermonimgdiv">
                    <Row className="align-items-center w-100 g-4">
                      <Col lg={7} md={12}>
                        <div className="home-hero-content" id="homebanner">
                          <div className="home-hero-badge">
                            <ReactTyped strings={["WELCOME TO"]} typeSpeed={120} loop />
                          </div>
                          <h1 className="home-hero-title">
                            ADE AJALA MINISTRIES
                          </h1>
                          <hr className="home-hero-divider" />
                          <p className="home-hero-desc">
                            We strive to empower individuals to depeen their relationship <br className="d-none d-md-inline" />
                            with God and live out their faith in meaningful ways
                          </p>
                          <div className="home-hero-btn-group">
                            <Link to='/livestream' reloadDocument className='btn btn-danger slidebtn' id='btn'>
                              JOIN SERVICE
                            </Link>
                            <Link to='/events' reloadDocument className='btn btn-danger slidebtn aam-btn-outline' id='btn'>
                              UPCOMING EVENT
                            </Link>
                          </div>
                        </div>
                      </Col>
                      <Col lg={5} md={12}>
                        <div className="home-hero-image-wrap" id="homeaboutimgdiv">
                          <Image src="images/eventimg.png" alt="Upcoming Events" fluid id="homeaboutimg" className="home-hero-image" />
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Carousel.Item>
              </Carousel>
            </div>
          </Container>
        </Fade>
      </section>

      {/* 2. GRANDMA'S BURIAL FLIPBOOK */}
      <section className="flipbook-memorial-section home-section-spacer">
        <Container>
          <Row className='align-items-center g-5'>
            <Col lg={5} md={12} className='text-center text-lg-start'>
              <span className="flipbook-memorial-badge">
                In Loving Memory
              </span>
              <h2 className="flipbook-memorial-title">
                Grandma's <br />
                <em>Burial</em>
              </h2>
              <hr className="flipbook-memorial-divider" />
              <h4 className="flipbook-memorial-subtitle">
                Matriarch Comfort Ajala
              </h4>
              <p className="flipbook-memorial-desc">
                Flip through the pages of this commemorative magazine dedicated 
                to celebrating the life, faith, and legacy of our beloved Matriarch. 
                A life well lived, a faith well kept.
              </p>
            </Col>
            <Col lg={7} md={12}>
              <div className="flipbook-iframe-container">
                <iframe
                  src="https://heyzine.com/flip-book/741b8b8b36.html"
                  allowFullScreen
                  title="Grandma's Burial - Matriarch Comfort Ajala"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* 3. ABOUT US */}
      <section id="sectionmargin" className='homeabout home-section-spacer'>
        <Container>
          <div className="section-title-wrap">
            <h2 id="bluecolor" className="section-title-heading">About Us</h2>
            <hr className="section-title-divider" />
          </div>

          <Fade delay={200} duration={1500}>
            <Row className="align-items-center g-4 justify-content-center">
              <Col lg={5} md={10} sm={12} className="text-center">
                <div className="about-image-card" id='homeaboutimgdiv'>
                  <Image src="images/about.png" alt="About Ade Ajala Ministries" fluid id="homeaboutimg" />
                </div>
              </Col>
              <Col lg={7} md={10} sm={12}>
                <div id="homeourmission">
                  {/* Mission Card */}
                  <div className="about-info-card">
                    <div className="about-icon-pill">
                      <FontAwesomeIcon icon={faBible} />
                    </div>
                    <div className="about-info-content">
                      <h5 id='bluecolor'>Our Mission</h5>
                      <p>
                        Our mission is to raise champions <br className="d-none d-sm-inline" />for kingdom assignment and see<br className="d-none d-sm-inline" />
                        lives transformed.
                      </p>
                    </div>
                  </div>

                  {/* Vision Card */}
                  <div className="about-info-card">
                    <div className="about-icon-pill">
                      <FontAwesomeIcon icon={faHeart} />
                    </div>
                    <div className="about-info-content">
                      <h5 id='bluecolor'>Our Vision</h5>
                      <p>
                        Changing nations, one life at a <br className="d-none d-sm-inline" />time
                      </p>
                      <div className="mt-3">
                        <Link to='/about' reloadDocument className='btn btn-danger' id='btn'>
                          Read More
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Fade>
        </Container>
      </section>

      {/* 4. DONATION / GIVING / VOLUNTEERING */}
      <section className="home-section-spacer">
        <Container>
          <Row className="g-4 align-items-stretch">
            <Col lg={4} md={4} sm={12} className="give-card-col">
              <Link to='/donation' reloadDocument className="give-card-link">
                <Card id="deptcard" className="give-card give-card-donate" style={{ backgroundColor: '#000080', color: '#fff' }}>
                  <div className="give-card-icon-wrap">
                    <FontAwesomeIcon icon={faGift} />
                  </div>
                  <h3 className="give-card-title">Donate</h3>
                  <p className="give-card-text">
                    With your support, we can continue spreading God's love, reaching out to those in need, and making a positive impact in our community and beyond.
                  </p>
                </Card>
              </Link>
            </Col>

            <Col lg={4} md={4} sm={12} className="give-card-col">
              <Link to='/giving' reloadDocument className="give-card-link">
                <Card id="deptcard" className="give-card give-card-give" style={{ backgroundColor: '#FF4500', color: '#fff' }}>
                  <div className="give-card-icon-wrap">
                    <FontAwesomeIcon icon={faDollar} />
                  </div>
                  <h3 className="give-card-title">Give</h3>
                  <p className="give-card-text">
                    Your giving is a powerful act of worship and generosity. You are not only supporting the work of God's kingdom but also sowing seeds of blessings in your own life.
                  </p>
                </Card>
              </Link>
            </Col>

            <Col lg={4} md={4} sm={12} className="give-card-col">
              <Link to='/volunteers' reloadDocument className="give-card-link">
                <Card id="deptcard" className="give-card give-card-volunteer" style={{ backgroundColor: '#0085FF', color: '#fff' }}>
                  <div className="give-card-icon-wrap">
                    <FontAwesomeIcon icon={faHeart} />
                  </div>
                  <h3 className="give-card-title">Volunteer</h3>
                  <p className="give-card-text">
                    Your giving is a powerful act of worship and generosity. You are not only supporting the work of God's kingdom but also sowing seeds of blessings in your own life.
                  </p>
                </Card>
              </Link>
            </Col>
          </Row>
        </Container>
      </section>

      {/* 5. APP DOWNLOAD */}
      <section className="home-section-spacer">
        <Container>
          <Fade delay={200} duration={1500}>
            <div className="app-download-container">
              <Row className="align-items-center g-5">
                <Col lg={7} md={12}>
                  <div id="downloaddiv">
                    <h2 id="apphead" className="app-download-title">ADE-AJALA MOBILE APP</h2>
                    <p id="whitecolor" className="app-download-desc">
                      Experience the convenience of staying connected with Ade-Ajala Ministries wherever you go by downloading our mobile app. With our app, you can access a wealth of spiritual resources, inspiration, and community engagement features right at your fingertips.
                    </p>
                    <div className="app-store-btn-group">
                      <Link to="#" className='app-store-btn' id="downloadbtn">
                        <Image src="images/appstore.png" alt="Download on App Store" fluid />
                      </Link>
                      <Link to="#" className='app-store-btn' id="downloadbtn">
                        <Image src="images/playstore.png" alt="Get it on Google Play" fluid />
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col lg={5} md={12}>
                  <div id="appimg" className="app-phone-mockup-wrap">
                    <Image fluid src="images/app.png" alt="AAM Mobile App Preview" />
                  </div>
                </Col>
              </Row>
            </div>
          </Fade>
        </Container>
      </section>

      {/* 6. LIVE STREAM */}
      <section className="home-section-spacer">
        <Container>
          <Fade delay={200} duration={1500}>
            <div className="livestream-banner">
              <Row className="align-items-center g-4">
                <Col lg={8} md={12}>
                  <div id="faithid">
                    <div className="livestream-badge">
                      <span className="livestream-badge-dot"></span>
                      Broadcast Live
                    </div>
                    <h2 id="whitecolor" className="livestream-title">
                      GET CONNTECTED WITH<br />
                      BISHOP ISREAL ADE-AJALA
                    </h2>
                    <p id="whitecolor" className="livestream-schedule">
                      EVERY FRIDAY BY 12:30pm
                    </p>
                    <div id="homegivebtnid" className="pt-2">
                      <Link to="/livestream" className='btn btn-danger' id="homegivebtn" reloadDocument>
                        JOIN US LIVE
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col lg={4} md={12}>
                  <div id='getconnected' className="livestream-portrait-wrap">
                    <Image fluid src="images/pastor2.jpeg" id='getconnectedimg' alt="Bishop Isreal Ade-Ajala" className="livestream-portrait-avatar" />
                  </div>
                </Col>
              </Row>
            </div>
          </Fade>
        </Container>
      </section>

      {/* 7. MESSAGES / SERMONS */}
      {sermons && sermons.length > 0 && (
        <section id="sectionmargin" className='homeabout home-section-spacer'>
          <Fade delay={200} duration={1500}>
            <Container>
              <div className="section-title-wrap">
                <h2 id="bluecolor" className="section-title-heading">Messages</h2>
                <hr className="section-title-divider" />
              </div>
              <div id='homesermonimgdiv'>
                {sermons.map((sermonData, idx) => {
                  return (
                    <div className="sermon-card-wrap mb-4" key={idx}>
                      <Row className="align-items-center g-4">
                        <Col lg={6} md={12}>
                          <div className="sermon-video-frame">
                            <iframe
                              src={sermonData.sermons_file}
                              title={sermonData.sermons_title || "Sermon Video"}
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                              allowFullScreen>
                            </iframe>
                          </div>
                        </Col>
                        <Col lg={6} md={12}>
                          <div id="homeourmission" className="sermon-details-wrap">
                            <span className="sermon-badge" id="bluecolor">
                              MESSAGES
                            </span>
                            <div className="sermon-date-pill">
                              {sermonData.sermons_date}
                            </div>
                            <h3 className="sermon-title">{sermonData.sermons_title}</h3>
                            <p className="sermon-excerpt">
                              Join us as we journey together in faith, seeking God's presence and sharing His love with the world. No matter where you are in your spiritual journey, you are welcome here at Ade Ajala Ministries. We look forward to walking alongside you as we grow together in Christ.
                            </p>
                            <div>
                              <Link to='/sermons' reloadDocument className='btn btn-danger' id='btn'>
                                DISCOVER MORE
                              </Link>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  );
                })}
              </div>
            </Container>
          </Fade>
        </section>
      )}

      {/* 8. PODCAST */}
      <section className="home-section-spacer">
        <Container>
          {podcasts && podcasts.length > 0 ? (
            podcasts.map((podcastsData, idx) => {
              return (
                <React.Fragment key={idx}>
                  {podcastsData.podcasts_title !== '' ? (
                    <div className="podcast-container-card">
                      <h3 id="bluecolor" className='homepodcast podcast-heading'>PODCAST</h3>
                      <Row className="align-items-center g-4">
                        <Col lg={4} md={12} className="text-center text-lg-start">
                          <h5 style={{ fontWeight: 'bold' }} className="bluecolor mb-0">
                            {podcastsData.podcasts_title}
                          </h5>
                        </Col>
                        <Col lg={8} md={12}>
                          <div className='podcastalign d-flex flex-column flex-md-row align-items-center gap-3'>
                            <div className="podcast-audio-custom-wrap flex-grow-1 w-100">
                              <audio controls>
                                <source src={podcastsData.podcasts_file} type="audio/mpeg" />
                              </audio>
                            </div>
                            <Link to='/podcast' reloadDocument className='btn btn-danger text-nowrap' id='btn'>
                              LISTEN MORE
                            </Link>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    <Card id="deptcard" className="p-4 text-center">
                      <Card.Body>
                        <Card.Title>No Podcast For Now</Card.Title>
                      </Card.Body>
                    </Card>
                  )}
                </React.Fragment>
              );
            })
          ) : (
            <Card id="deptcard" className="p-4 text-center">
              <Card.Body>
                <Card.Title>No Podcast For Now</Card.Title>
              </Card.Body>
            </Card>
          )}
        </Container>
      </section>

      {/* 9. KCILE */}
      <section id="sectionmargin" className='homeabout home-section-spacer'>
        <Fade delay={200} duration={1500}>
          <Container>
            <div id='homesermonimgdiv' className="feature-banner-card kcile-bg">
              <Row className="align-items-center g-5">
                <Col lg={7} md={12} className="text-center text-lg-start">
                  <div id="homeourmission">
                    <h3 id="bluecolor" className="feature-card-title">
                      KINGDOM CONNTECTION INSTITUTE <br className="d-none d-sm-inline" />LIFE EMPOWERMENT
                    </h3>
                    <p className="feature-card-desc">
                      Welcome to Kingdom Connection Institute - your gateway to life empowerment and spiritual growth. Our institute is dedicated to providing transformative teachings and resources that empower individuals to live purposefully and abundantly in alignment with God's kingdom principles.
                      At Kingdom Connection Institute, we offer a range of life empowerment programs designed to nurture personal development, spiritual growth, and leadership skills. Through dynamic teachings, practical workshops, and impactful resources, we equip individuals with the tools and insights needed to navigate life's challenges and unlock their full potentials.
                    </p>
                  </div>
                  <div>
                    <Link to='/kcile' reloadDocument className='btn btn-danger' id='btn'>
                      Apply Now
                    </Link>
                  </div>
                </Col>
                <Col lg={5} md={12}>
                  <div id='homekcileimgdiv' className="feature-card-img-wrap">
                    <Image src="images/kcilelogo.png" alt="KCILE Logo" fluid id="homekcileimg" />
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </Fade>
      </section>

      {/* 10. E-STORE */}
      <section id="sectionmargin" className='homeabout home-section-spacer'>
        <Fade delay={200} duration={1500}>
          <Container>
            <div id='homesermonimgdiv' className="feature-banner-card">
              <Row className="align-items-center g-5">
                <Col lg={5} md={12}>
                  <div id='homestoreimgdiv' className="feature-card-img-wrap">
                    <Image src="images/estore.png" alt="AAM E-Store" fluid id="homeaboutimg" />
                  </div>
                </Col>
                <Col lg={7} md={12} className="text-center text-lg-start">
                  <div id="homeourmission">
                    <h3 id="bluecolor" className="feature-card-title">
                      E-STORE
                    </h3>
                    <p className="feature-card-desc">
                      Welcome to our e-store, where faith meets literature in a harmonious blend of inspiration and knowledge. Dive into a world where words ignite the spirit and illuminate the path to enlightenment. Our collection of faith-filled books is carefully curated to cater to the spiritual seeker, the devout believer, and the curious soul alike.
                    </p>
                  </div>
                  <div>
                    <Link to='https://adeajalaministries.org/aamstore' reloadDocument className='btn btn-danger' id='btn' target='_blank'>
                      EXPLORE MORE
                    </Link>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </Fade>
      </section>

      {/* 11. PRAYER REQUEST */}
      <section id="sectionmargin" className='homeabout home-section-spacer'>
        <Fade delay={200} duration={1500}>
          <Container>
            <div
              id='homesermonimgdiv'
              className="prayer-section-wrap"
              style={{ backgroundImage: "url(/images/course3.png)" }}
            >
              <div className="prayer-section-overlay">
                <Row className="justify-content-end">
                  <Col lg={6} md={10} sm={12}>
                    <div id="homeourmission">
                      <Card id="deptcard" className="prayer-card">
                        <Card.Header className="prayer-card-header">
                          PRAYER REQUEST
                        </Card.Header>
                        <Card.Body className="prayer-card-body">
                          <Form>
                            <InputGroup className="mb-3">
                              <Form.Control
                                type="text"
                                placeholder="Name"
                                className="prayer-input-control"
                                value={prayeruser_name}
                                onChange={(e) => setPrayerUserName(e.target.value)}
                              />
                            </InputGroup>

                            <InputGroup className="mb-3">
                              <Form.Control
                                type="email"
                                placeholder="Email"
                                className="prayer-input-control"
                                value={prayeruser_email}
                                onChange={(e) => setPrayerUserEmail(e.target.value)}
                              />
                            </InputGroup>

                            <InputGroup className="mb-3">
                              <Form.Control
                                type="text"
                                placeholder="Pnone Number"
                                className="prayer-input-control"
                                value={prayeruser_pnum}
                                onChange={(e) => setPrayerUserPnum(e.target.value)}
                              />
                            </InputGroup>

                            <Form.Group className="mb-3">
                              <Form.Control
                                type="text"
                                placeholder="Message"
                                as="textarea"
                                rows={3}
                                className="prayer-input-control"
                                value={prayeruser_request}
                                onChange={(e) => setPrayerRequest(e.target.value)}
                              />
                            </Form.Group>
                          </Form>

                          <div>
                            {messagep === 'success' && (
                              <div className='alert alert-success alert-sm'>
                                {successmessagep}
                              </div>
                            )}

                            {messagep === 'error' && (
                              <div className='alert alert-danger alert-sm'>
                                {errormessagep}
                              </div>
                            )}
                          </div>

                          <ButtonToolbar className="justify-content-between">
                            <ButtonGroup className="w-100">
                              {buttontextp === "Processing" ? (
                                <Button
                                  className="w-100 btn btn-danger"
                                  style={{ backgroundColor: '#249D59', color: '#fff', border: 'none', fontWeight: 'bold' }}
                                  onClick={Save}
                                >
                                  {buttontextp}
                                </Button>
                              ) : (
                                <Button
                                  className="w-100 btn btn-danger"
                                  style={{ backgroundColor: 'red', color: '#fff', border: 'none', fontWeight: 'bold' }}
                                  onClick={Save}
                                >
                                  {buttontextp}
                                </Button>
                              )}
                            </ButtonGroup>
                          </ButtonToolbar>
                        </Card.Body>
                      </Card>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Container>
        </Fade>
      </section>

      {/* 12. CONTACT & SOCIAL STRIP */}
      <section id="sectionmargin" className='homeabout home-section-spacer'>
        <Fade delay={200} duration={1500}>
          <Container>
            <div id='homesermonimgdiv' className="contact-strip-wrap">
              <Row className="align-items-center g-4">
                <Col lg={6} md={12} className="text-center text-lg-start">
                  <div id="homecontactdiv">
                    <p className="contact-strip-text">
                      At Ade-Ajala Ministries, we value your feedback, enquiries and connections. Reach out to us effortlessly through email or any of our active social media platform.
                    </p>
                  </div>
                </Col>
                <Col lg={4} md={8} sm={12}>
                  <div id='homesocialmedia'>
                    <div className="contact-social-btn-group">
                      <Link to="https://facebook.com/KcccDenver" reloadDocument className='contact-social-btn' id="homesocialbtn" target='_blank' rel="noreferrer">
                        <FontAwesomeIcon icon={faFacebook} />
                      </Link>
                      <Link to="https://instagram.com/Kcccaurora" reloadDocument className='contact-social-btn' id="homesocialbtn" target='_blank' rel="noreferrer">
                        <FontAwesomeIcon icon={faInstagram} />
                      </Link>
                      <Link to="https://twitter.com/pastorade" reloadDocument className='contact-social-btn' id="homesocialbtn" target='_blank' rel="noreferrer">
                        <FontAwesomeIcon icon={faTwitter} />
                      </Link>
                      <Link to="https://youtube.com/@adeajalaministries" reloadDocument className='contact-social-btn' id="homesocialbtn" target='_blank' rel="noreferrer">
                        <FontAwesomeIcon icon={faYoutube} />
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col lg={2} md={4} sm={12} className="text-center text-lg-end">
                  <div id='homecontact'>
                    <Link to='#' reloadDocument className='btn btn-danger text-nowrap' id='btn'>
                      CONTACT US
                    </Link>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </Fade>
      </section>

      {/* 13. QR CODE SECTION */}
      <section className="home-section-spacer">
        <Fade delay={200} duration={1500}>
          <Container>
            <div id="storecontainer" className="qr-section-card">
              <Row className="align-items-center g-4">
                <Col lg={7} md={12} className="text-center text-lg-start">
                  <div id="homeqrid">
                    <h3 id="bluecolor" className="qr-section-title">SCAN ME</h3>
                    <p className="qr-section-desc">
                      We'd love to get to know you better!. Simply scan the QR code and fill out the form to help us build a stronger, Christ-centered community together. Let's grow in faith, love and connection!
                    </p>
                    <a href="images/kcccqr.jpg" target='_blank' rel="noreferrer" className='btn btn-danger' id="homegivebtn">
                      Scan Me Now
                    </a>
                  </div>
                </Col>
                <Col lg={5} md={12} className="text-center text-lg-end">
                  <div className="qr-image-frame">
                    <Image fluid src="images/kcccqr.jpg" id='qrimage' alt="KCCC QR Code" />
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </Fade>
      </section>

      {/* 14. LATEST NEWS SECTION (WITH 4-NEWS-PER-ROW DUPLICATION) */}
      <section className="home-section-spacer">
        <Container>
          <div className="section-title-wrap">
            <h2 id="bluecolor" className="section-title-heading">LATEST NEWS</h2>
            <hr className="section-title-divider" />
          </div>

          {newsRows.length > 0 ? (
            newsRows.map((rowChunk, rowIndex) => (
              <Row className="g-4 news-row-wrap" key={`news-row-${rowIndex}`}>
                {rowChunk.map((newsData, colIndex) => (
                  <Col lg={3} md={6} sm={12} key={`news-${newsData.news_id || colIndex}-${rowIndex}-${colIndex}`}>
                    <div id="deptcard" className="news-modern-card">
                      <div className="news-img-container">
                        <img
                          src={newsData.news_file}
                          alt={newsData.news_title || "News"}
                          onError={(e) => { e.target.src = "images/about.png"; }}
                        />
                        {newsData.news_date && (
                          <div className="news-date-badge">
                            {newsData.news_date}
                          </div>
                        )}
                      </div>
                      <div className="news-card-body">
                        <h4 id="bluecolor" className="news-card-title">
                          {newsData.news_title}
                        </h4>
                        <div className="news-card-btn-wrap">
                          <Link
                            to={"/news-details?newsid=" + newsData.news_id}
                            className="news-card-btn"
                            reloadDocument
                          >
                            New Details
                          </Link>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            ))
          ) : (
            <Row>
              <Col md={12}>
                <Card id="deptcard" className="p-4 text-center">
                  <Card.Body>
                    <Card.Title>No News For Now</Card.Title>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}

          <div className="text-center mt-5">
            <Link to='/news' reloadDocument className='btn btn-danger' id='btn'>
              Read More
            </Link>
          </div>
        </Container>
      </section>

      {/* 15. PUBLICATIONS */}
      <section id="sectionmargin" className='homeabout home-section-spacer'>
        <Container>
          <div className="section-title-wrap">
            <h2 id="bluecolor" className="section-title-heading">Our Publications</h2>
            <hr className="section-title-divider" />
            <p className="section-title-subtitle">
              Explore our digital magazines, bulletins, and program books — faith-filled resources to keep you informed, inspired, and connected.
            </p>
          </div>

          <Row className="g-4">
            {publications.map((pub) => (
              <Col lg={4} md={6} sm={12} key={pub.id}>
                <div id="deptcard" className="pub-modern-card">
                  {/* STATIC PREVIEW THUMBNAIL */}
                  <div className="pub-iframe-preview">
                    <iframe
                      src={pub.flipbook_url}
                      title={pub.title}
                    />
                  </div>

                  <div className="pub-card-body">
                    {pub.category && (
                      <span className="pub-category-tag">
                        {pub.category}
                      </span>
                    )}
                    <h4 id="bluecolor" className="pub-card-title">{pub.title}</h4>
                    {pub.desc && (
                      <p className="pub-card-desc">{pub.desc}</p>
                    )}
                    {pub.date && (
                      <div>
                        <span className="pub-date-badge">
                          {pub.date}
                        </span>
                      </div>
                    )}
                    <div className="mt-auto">
                      <Button
                        style={{ backgroundColor: 'red', border: 'none', borderRadius: '6px', fontWeight: '700', fontSize: '13px', padding: '10px 20px', width: '100%' }}
                        onClick={() => openFlipbook(pub.title, pub.flipbook_url)}
                      >
                        READ PUBLICATION
                      </Button>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          <div className="text-center mt-5">
            <Link to='/publications' reloadDocument className='btn btn-danger' id='btn'>
              VIEW ALL PUBLICATIONS
            </Link>
          </div>
        </Container>

        {/* FLIPBOOK MODAL */}
        <Modal
          show={showFlipbook}
          onHide={closeFlipbook}
          size="xl"
          centered
          fullscreen="lg-down"
        >
          <Modal.Header closeButton style={{ backgroundColor: '#204782', color: '#fff' }}>
            <Modal.Title style={{ fontSize: '16px', fontWeight: '700' }}>
              {activeFlipbook.title}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: 0, backgroundColor: '#000' }}>
            <div style={{ position: 'relative', paddingBottom: '75vh', height: 0 }}>
              {showFlipbook && (
                <iframe
                  src={activeFlipbook.url}
                  allowFullScreen
                  title={activeFlipbook.title}
                  style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
                />
              )}
            </div>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: '#204782' }}>
            <Button
              style={{ backgroundColor: 'red', border: 'none', borderRadius: '0', fontWeight: '700' }}
              onClick={closeFlipbook}
            >
              CLOSE
            </Button>
          </Modal.Footer>
        </Modal>
      </section>

    </div>
  );
};
